import React from 'react';
import { Box, Typography } from 'vindi-ds-components';

function Headline({ title, description }) {
  return (
    <Box data-testid='onboard_headline'>
      <Box display='flex' flexDirection='column' css={{ gap: '8px', margin: '1em 0 0 1em' }}>
        <Typography variant='body1'>
          {description}
        </Typography>
        <Typography variant='subtitle1' weight='medium'>
          {title}
        </Typography>
      </Box>
    </Box>
  );
}

export default Headline;
